import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import Collapse from '@mui/material/Collapse';
import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListItemIcon from "@mui/material/ListItemIcon";
import Icon from "@mui/material/Icon";
import MDBox from "components/MDBox";
import { useMaterialUIController } from "context";

import {
  collapseItem,
  collapseIconBox,
  collapseText,
} from "examples/Sidenav/styles/sidenavCollapse";

function ListItemHeader(props) {
  const { name, icon, showIcon, open, onClick } = props;
  const [controller] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;
  let expandIcon = open ? <ExpandLess /> : <ExpandMore />;
  const location = useLocation();
  const active = location.pathname.replace("/", "") === name.replace("/", "");

  return (
    <MDBox
      sx={(theme) =>
        collapseItem(theme, {
          active,
          transparentSidenav,
          whiteSidenav,
          darkMode,
          sidenavColor,
        })
      }
      style={{ height: 30 }}
      onClick={onClick}
    >
      {showIcon ? (
        <ListItemIcon
          sx={(theme) =>
            collapseIconBox(theme, { transparentSidenav, whiteSidenav, darkMode, active })
          }
        >
          <Icon fontSize="small">{icon}</Icon>
        </ListItemIcon>
      ) : (
        ""
      )}

      <ListItemText
        primary={name}
        sx={(theme) =>
          collapseText(theme, {
            miniSidenav,
            transparentSidenav,
            whiteSidenav,
            active,
          })
        }
      />

      <MDBox px={2} style={{ color: "white" }}>{expandIcon}</MDBox>

    </MDBox>
  );
}

function ListItemLink(props) {
  const { to, name, icon, showIcon, ...other } = props;
  const [controller] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;
  const location = useLocation();
  const active = location.pathname.replace("/", "") === to.replace("/", "");

  return (
    <ListItem button component={RouterLink} to={to} {...other} >
      <MDBox
        sx={(theme) =>
          collapseItem(theme, {
            active,
            transparentSidenav,
            whiteSidenav,
            darkMode,
            sidenavColor,
          })
        }
        style={{ height: 30 }}
      >
        {showIcon ? (
          <ListItemIcon
            sx={(theme) =>
              collapseIconBox(theme, { transparentSidenav, whiteSidenav, darkMode, active })
            }
          >
            <Icon fontSize="small">{icon}</Icon>
          </ListItemIcon>
        ) : (
          ""
        )}
        <ListItemText
          primary={name}
          sx={(theme) =>
            collapseText(theme, {
              miniSidenav,
              transparentSidenav,
              whiteSidenav,
              active,
            })
          }
        />
      </MDBox>
    </ListItem>
  );
}

export default function CollapseSidenav() {

  const [menuMap, setMenuMap] = useState([]);

  const right = useSelector(state => state.common.rights);
  const groupId = useSelector(state => state.common.groupId);
  const verifiedEntityLevel = useSelector(state => state.common.verifiedEntityLevel);

  const refreshMenu = () => {

    const menu = [];

    // Anasayfa (her zaman)
    menu.push({
      key: 0,
      to: '/',
      name: 'Anasayfa',
      icon: 'home',
      items: [],
    });

    // Gönderim → Right != 5
    if (right !== "5") {   
      menu.push({
        key: menu.length,
        to: '/GonderimRaporu',
        name: 'Gönderim Raporu',
        icon: 'business',
        items: [],
      });
    }

    // Numara Sorgulama → her zaman
    menu.push({
      key: menu.length,
      to: '/NumaraSorgulama',
      name: 'Numara Sorgulama',
      icon: 'manage_search',
      items: [],
    });

    // Alfanümerik → GroupId > 0 && Right != 5
    if (groupId > "0" && right !== "5") {     
      menu.push({
        key: menu.length,
        to: '/AlfanumerikRaporu',
        name: 'Alfanümerik Raporu',
        icon: 'summarize',
        items: [],
      });
    }

    // Firma → GroupId > 0 && Right IN (2,3,4)
    if (groupId > "0" && ["2", "3", "4"].includes(right)) {     
      menu.push({
        key: menu.length,
        to: '/FirmaRaporu',
        name: 'Firma Raporu',
        icon: 'apartment',
        items: [],
      });
    }

    // Günlük → Right IN (2,4)
    if (["2", "4"].includes(right)) {
      menu.push({
        key: menu.length,
        to: '/GunlukRapor',
        name: 'Günlük Rapor',
        icon: 'event_note',
        items: [],
      });
    }

    // Diğer sabit menüler
    menu.push(
      {
        key: menu.length,
        to: '/Sorgular',
        name: 'Sorgular',
        icon: 'dashboard',
        items: [],
      },      
    );
    
    if (verifiedEntityLevel == "AccountMaster") {
      menu.push({
        key: menu.length + 1,
        to: '/KullaniciYonetimi',
        name: 'Kullanıcı Yönetimi',
        icon: 'account_box',
        items: [],
      });
    }

    setMenuMap(menu);
  };


  useEffect(() => {
   
    if(right > 0)
      refreshMenu();
  }, [right]);

  const [openMenu, setOpenMenu] = useState([]);

  useEffect(() => {
    refreshMenu();
  }, [openMenu]);

  const onClickHandler = (to, isSubMenu, mainMenuTo, e) => {
    if (openMenu === to && isSubMenu)
      setOpenMenu(mainMenuTo);
    else
      setOpenMenu(openMenu === to ? "" : to);
  }

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box
        component="nav"
        aria-label="mailbox folders"
      >
        {menuMap.map((menu) => (
          menu.items.length > 0 ?
            <li key={menu.key}>
              <ListItemHeader name={menu.name} icon={menu.icon} open={menu.open} showIcon={true} onClick={() => onClickHandler(menu.to, false, "")} />
              <Collapse in={menu.open} timeout="auto" unmountOnExit>
                {menu.items.map((submenu) => (
                  submenu.items.length > 0 ?
                    <ul key={submenu.key}>
                      <li key={submenu.key + 1}>
                        <ListItemHeader name={submenu.name} icon={submenu.icon} open={submenu.open} showIcon={false} onClick={() => onClickHandler(submenu.to, true, menu.to)} />
                        <Collapse in={submenu.open} timeout="auto" unmountOnExit>
                          {submenu.items.map((submenuitem) => (
                            <ListItemLink key={submenuitem.key} name={submenuitem.name} to={submenuitem.to} showIcon={false} icon={menu.icon} />
                          ))}

                        </Collapse>
                      </li></ul>
                    : <ListItemLink key={submenu.key} name={submenu.name} to={submenu.to} showIcon={false} icon={menu.icon} />
                ))}
              </Collapse>
            </li>
            : <ListItemLink key={menu.key} name={menu.name} to={menu.to} showIcon={true} icon={menu.icon} />
        ))}
      </Box>
    </Box>
  );
}